import Main from "../../../layouts/Main";
import Card from "../../../components/Card";
import Tab from "../../../components/Tab";
// import General from './General/DisbursmentWorkerReport'
import DisbursmentWorkerReport from "./GeneralV2/General";
import Mitra10 from "./Mitra10/DisbursmentWorkerReport";

const DisbursmentWorker = () => {
  const data = [
    // {
    //   name: 'General',
    //   id: '#tab1',
    //   content: <General />,
    // },
    {
      name: "General",
      id: "#tab2",
      content: <DisbursmentWorkerReport />,
    },
    // {
    //   name: 'Mitra10',
    //   id: '#tab3',
    //   content: <Mitra10 />,
    // },
  ];

  return (
    <Main title="Report Disbursment Worker">
      <Card col={"col-xl-12 col-lg-12"}>
        <Tab data={data} defaultId={data[0].id} defaultContent={data[0].content} Dnone={true} />
      </Card>
    </Main>
  );
};

export default DisbursmentWorker;
